import styled from "styled-components";
import { theme } from "@upsolve/ui";

const HorizontalRule = styled.hr`
  margin: 1em 0;
  border: 1px solid ${theme.colors.white["500"]};
`;

export default HorizontalRule;
